import { Box, Typography } from '@mui/material';
import useStyles from './useStyles';
import React, { useEffect, useState } from 'react';
import EducationDialog from './EdDialog';
import WorkDialog from './WorkDialog';
import { UserModel } from '../../../types/User';
import { CellType } from '../../../types/Common';
import {
  GenderOptions,
  JobGroupOptions,
  MaritalStatusOptions,
  MilitaryStatusOption,
} from '../../../constants/options';
import { getUsersResumes } from '../../../apis/user';
import CustomTable from '../../../components/UI/CustomTable';
import CustomPagination from '../../../components/UI/CustomPagination';
import CustomSelect from '../../../components/UI/CustomSelect';
import { selectOptionsJobGroup } from '../../../constants/translate';
import CustomButton from '../../../components/UI/CustomButton';

const UsersResume = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [workExperience, setWorkExperience] = useState<any>([]);
  const [educationalBackground, setEducationalBackground] = useState<any>([]);
  const [fullName, setFullName] = useState('');
  const [jobGroupValue, setJobGroupValue] = useState('');

  const EDAction = (row: any) => {
    const { educationalBackground = [], name, lastName } = row || {};

    if (Array.isArray(educationalBackground) && educationalBackground.length > 0)
      return (
        <Typography
          color='primary.main'
          className={classes.actionTypography}
          onClick={() => {
            setEducationalBackground(educationalBackground);
            setFullName(`${name} ${lastName}`);
          }}
        >
          نمایش
        </Typography>
      );
    else return <span>---</span>;
  };

  const WorkAction = (row: any) => {
    const { workExperience = [], name, lastName } = row || {};

    if (Array.isArray(workExperience) && workExperience.length > 0)
      return (
        <Typography
          color='primary.main'
          className={classes.actionTypography}
          onClick={() => {
            setWorkExperience(workExperience);
            setFullName(`${name} ${lastName}`);
          }}
        >
          نمایش
        </Typography>
      );
    else return <span>---</span>;
  };

  const tableHead = [
    {
      key: 'row',
      label: 'ردیف',
      type: CellType.ROW,
    },
    {
      key: 'name',
      label: 'نام',
      type: CellType.STRING,
    },
    {
      key: 'lastName',
      label: 'نام خانوادگی',
      type: CellType.STRING,
    },
    {
      key: 'mobileNumber',
      label: 'شماره موبایل',
      type: CellType.MOBILE,
    },
    {
      key: 'fieldOfExpertise',
      label: 'گروه شغلی',
      type: CellType.ENUM,
      options: JobGroupOptions,
    },
    {
      key: 'gender',
      label: 'جنسیت',
      type: CellType.ENUM,
      options: GenderOptions,
    },
    {
      key: 'maritalStatus',
      label: 'وضعیت تاهل',
      type: CellType.ENUM,
      options: MaritalStatusOptions,
    },
    {
      key: 'maritalStatus',
      label: 'وضعیت نظام وظیفه',
      type: CellType.ENUM,
      options: MilitaryStatusOption,
    },
    {
      key: 'email',
      label: 'ایمیل',
      type: CellType.STRING,
    },
    {
      key: 'age',
      label: 'سن',
      type: CellType.NUMBER,
    },

    {
      key: 'residenceProvince',
      label: 'استان',
      type: CellType.STRING,
    },
    {
      key: 'careerBio',
      label: 'bio',
      type: CellType.STRING,
    },
    {
      key: 'educationalBackground',
      label: 'سابقه تحصیلی',
      type: CellType.ACTION,
      action: EDAction,
    },
    {
      key: 'workExperience',
      label: 'سابقه شغلی',
      type: CellType.ACTION,
      action: WorkAction,
    },
  ];

  const getAllUsersResume = () => {
    setLoading(true);
    const query = `?page=${currentPage}&job_group=${jobGroupValue}`;
    getUsersResumes(query)
      .then((res: any) => {
        setUsers(res.data || []);
        setTotalPages(res.pagination?.totalPages || 1);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (jobGroupValue) getAllUsersResume();
  }, [currentPage]);

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.topContainer} mb={1}>
        <CustomSelect
          value={jobGroupValue}
          onChange={(value: string) => setJobGroupValue(value)}
          options={selectOptionsJobGroup}
          placeholder='گروه شغلی'
          fullWidth
        />

        <CustomButton
          loading={loading}
          disabled={loading || !jobGroupValue}
          onClick={getAllUsersResume}
        >
          <Typography px={2}>اعمال فیلتر</Typography>
        </CustomButton>
      </Box>

      <CustomTable rows={users} tableHead={tableHead} loading={loading} />

      {users && users.length > 0 && (
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChangeCurrentPage={(page: number) => setCurrentPage(page)}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={(rowsPerPage: number) => {
            if (currentPage !== 0) setCurrentPage(1);
            setRowsPerPage(rowsPerPage);
          }}
        />
      )}

      <EducationDialog
        educationalBackground={educationalBackground}
        closeDialog={() => setEducationalBackground([])}
        fullName={fullName}
      />

      <WorkDialog
        workExperience={workExperience}
        closeDialog={() => setWorkExperience([])}
        fullName={fullName}
      />
    </Box>
  );
};

export default UsersResume;
